module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IYquTl/tc-custom/9781913618292.jpg?1696084564562",
      "alt": "This image is the cover for the book I Ching, Ancient Wisdom for the New Age"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("I Ching, Ancient Wisdom for the New Age\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This comprehensive introduction to the I Ching explains how to unlock the secrets of this ancient form of divination.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The ancient Chinese formalized nature's shapes and forms into the I Ching, or Book of Changes, which is thought to be the oldest system of divination in the world. In the pages of the I Ching, we find sixty-four types of changes covering all of life’s transitions and laid out in symbol form as hexagrams and trigrams. "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This work explains how to follow a simple system of throwing coins to discern the appropriate symbols, then use the text and commentary and our own intuition to guide us towards certain action or knowledge. It also discusses how to use the ancient Taoist knowledge to promote self-awareness, positive health, and personal happiness.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Allie Woo\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Fox Chapel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0